function Camera(app) {

	this.videoEl;
	this.videoCanvas;
	this.videoCanvasCtx;

	this.p = app;

	this._hasStream = false;
	this.cameraResolution = {
		// width: 1920,
		// height: 1080
		width: 1280,
		height: 720
	}

	this.canvasResolution = {
		width: 1024,
		height: 1024
	}

	// Create the video element
	this.videoEl = document.createElement('video');
	this.videoEl.id = 'webcam-video';
	this.videoEl.setAttribute("crossOrigin", "Anonymous");
	this.videoEl.width = this.cameraResolution.width;
	this.videoEl.height = this.cameraResolution.height;

	this.videoCanvas = $(".camera-video");
	this.videoContexts = [];

	this.videoCanvas.each($.proxy(function (i, canvas) {
		canvas.width = this.canvasResolution.width;
		canvas.height = this.canvasResolution.height;

		this.videoContexts.push(canvas.getContext('2d'));
	}, this));

	$(this.videoContexts).each($.proxy(function (i, context) {
		context.fillStyle = '#FFF';
		context.fillRect(0, 0, this.canvasResolution.width, this.canvasResolution.height);
		context.translate(this.canvasResolution.width, 0);
		context.scale(-1, 1);
	}, this));

	this.timer = -1;
	this.timerCount = 5;

	// Create 2D texture
	// this.videoCanvas = document.createElement('canvas');
	// this.videoCanvas.id = 'webcam-canvas';
	// this.videoCanvas.width = this.cameraResolution.height * 8 / 9;
	// this.videoCanvas.height = this.cameraResolution.height;
	// this.videoCanvasCtx = this.videoCanvas.getContext('2d');
	// this.videoCanvasCtx.fillStyle = '#FFF';
	// this.videoCanvasCtx.fillRect(0, 0, this.videoCanvas.width, this.videoCanvas.height);

	var constraints = {
		audio: false,
		video: {
			width: {min: this.cameraResolution.width},
			height: {min: this.cameraResolution.height}
		}
	};

	navigator.getUserMedia(constraints,
		jQuery.proxy(this.onCameraAvailable, this),
		jQuery.proxy(this.onCameraUnavailable, this)
	);
}

Camera.prototype.onCameraAvailable = function (stream) {
	console.log("available")
	var url = window.URL;
	this.videoEl.src = url.createObjectURL(stream);
	// this.videoEl.play();

	this.play();
}

Camera.prototype.onCameraUnavailable = function (e) {
	console.log("error");
	console.log(e);
}

Camera.prototype.update = function () {
	if (this.videoEl.readyState === this.videoEl.HAVE_ENOUGH_DATA) {
		// this.videoCanvasCtx.drawImage(this.videoEl, 0, 0);
		// ctx.drawImage(image, sourceStartX, sourceStartY, sourceCropWidth, sourceCropHeight, dx, dy, dWidth, dHeight);

		// camera width: 1280
		// camera height: 720

		// height -> 1024
		// width -> 1024 * (320/360) = 426
		var sourceCropHeight = this.canvasResolution.height * ( this.cameraResolution.height / this.cameraResolution.width);
		var sourceCropWidth = this.canvasResolution.width * (this.cameraResolution.height / this.cameraResolution.width);
		// var sourceCropWidth = this.cameraResolution.height;
		var sourceStartX = (this.cameraResolution.width - sourceCropWidth) / 2;
		var sourceStartY = (this.cameraResolution.height - sourceCropHeight) / 2;

		$(this.videoContexts).each($.proxy(function (i, context) {
			context.drawImage(this.videoEl, sourceStartX, sourceStartY, sourceCropWidth, sourceCropHeight, 0, 0, this.canvasResolution.width, this.canvasResolution.height);
		}, this));
		// this.videoCanvasCtx.drawImage(this.videoEl, sourceStartX, 0, sourceCropWidth, sourceCropHeight, 0, 0, this.videoCanvas.width, this.videoCanvas.height);

		// this.videoCanvasCtx.drawImage(this.videoEl, 160, 0, 320, 360, 0, 0, this.videoCanvas.width, this.videoCanvas.height);

		// if (this.p.world.videoTexture)
		// 	this.p.world.videoTexture.needsUpdate = true;
	}
}

Camera.prototype.play = function () {
	console.log("play");
	// if (this.hasStream()) {
	this.loop();
	console.log("hasStream");

	this.videoEl.play();
	// }
}

Camera.prototype.pause = function () {
	if (this.hasStream()) {
		this.videoEl.pause();
	}
}

Camera.prototype.ended = function () {
	if (this.hasStream()) {
		this.isEnded = true;
	}
}

Camera.prototype.reset = function () {
	if (this.hasStream()) {
		this.isEnded = false;
		this.pause();
		this.videoEl.currentTime = 0;
	}
}

Camera.prototype.hasStream = function () {
	if (this._hasStream) {
		return true;
	} else if (this.videoEl.readyState === this.videoEl.HAVE_ENOUGH_DATA) {
		this._hasStream = true;
		return true;
	}
}

Camera.prototype.isPlaying = function () {
	if (this.hasStream()) {
		return !this.videoEl.paused;
	}
	return false;
}


Camera.prototype.loop = function (e) {
	// http://stackoverflow.com/questions/21924719/how-to-use-requestanimationframe-with-a-typescript-object
	requestAnimationFrame($.proxy(this.loop, this));
	this.update();
}

Camera.prototype.startTimer = function () {
	console.log("start timer");

	this.timerAction();
	this.timer = requestInterval($.proxy(this.timerAction, this), 1000);
}

Camera.prototype.timerAction = function () {
	$(".countdown").html(this.timerCount);
	this.timerCount--;
	if (this.timerCount < 0) {
		clearRequestInterval(this.timer);
		this.timerCount = 5;
		this.snapshot();
	}
}

Camera.prototype.snapshot = function () {
	var canvas = $("#main-camera")[0];

	// canvas.toBlob(function (blob) {
	// 	var newImg = $("#test")[0];
	//
	// 	// create an url object for our blob.
	// 	// we can assign that url to an image
	// 	var url = URL.createObjectURL(blob);
	//
	// 	newImg.onload = function () {
	// 		// no longer need to read the blob so it's revoked
	// 		// URL.revokeObjectURL(url);
	// 	};
	//
	// 	newImg.src = url;
	// });

	var base64Img = canvas.toDataURL("image/jpeg");

	$("#camera-image-receiver").attr("src", base64Img).load();

	this.p.pictureTaken(base64Img);
}

// Expose App
window.Camera = Camera;